'use strict';

var React = require('react');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
var mouseHelper = require('../../helper/mouseHelper');

/**
 * 水平滑块
 */
var VSlider2 = React.createClass({

  getInitialState: function () {
    return {
      progress: styleHelper.getInt(this.props, propConst.PROGRESS)
    };
  },

  render: function () {
    var trackStyle;
    var sliderStyle;
    var sliderClass = 'slide';
    var sliderHeight;
    var sliderContentStyle;
    var boxStyle;

    var isDisabled = this.getIsDisabled();
    var sliderColor = isDisabled ? '#DDD' : this.props.sliderColor;
    switch (this.props.sliderShapeType) {
    case 'SCircle':
      sliderClass += ' circle';
      sliderHeight = 15;
      sliderContentStyle = {
        backgroundColor: sliderColor
      };
      break;
    case 'SSquare':
      sliderClass += ' square';
      sliderHeight = 15;
      sliderContentStyle = {
        backgroundColor: sliderColor
      };
      break;
    default:
      sliderClass += ' incisive';
      sliderHeight = 4;
      sliderContentStyle = {
        borderLeftColor: sliderColor
      };
      break;
    }

    var progress = this.state.progress;
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);

    trackStyle = {
      left: (w - 2) / 2,
      backgroundColor: isDisabled ? '#DDD' : this.props.trackColor
    };

    sliderStyle = {
      top: Math.min((progress / 100) * h, h - sliderHeight)
    };

    boxStyle = {
      width: w,
      height: h
    };

    return (<div style={boxStyle} onClick={this.onTrackClick}>
      <div className="track" style={trackStyle}></div>
      <div onMouseDown={this.onDrag}
           onTouchStart={this.onDrag}
           onClick={this.onSliderClick}
           className={sliderClass} style={sliderStyle}>
        <div className="slide-shape" style={sliderContentStyle}></div>
      </div>
    </div>)
  },
  getIsDisabled: function () {
    var state = styleHelper.getPropertyValue(this.props, propConst.STATUS);
    if (!state) {
      state = this.props[propConst.STATE];
    }
    return state === appTypes.ComStatus2.DISABLE;
  },
  onDrag: function (e) {
    if (this.getIsDisabled()) {
      return;
    }
    var height = parseInt(this.props.h, 10);
    var self = this;
    var progress = this.state.progress;
    var unit = height / 100;
    mouseHelper.dragDelegate(function (e, delta) {
      self.setState({
        progress: Math.max(0, Math.min(delta.y / unit + progress, 100))
      });
      e.stopPropagation();
      e.preventDefault();
    }, function (e) {
      e.stopPropagation();
      e.preventDefault();
    });
    e.preventDefault();
  },
  onSliderClick: function (e) {
    e.stopPropagation();
  },
  onTrackClick: function (e) {
    var parent = e.target.parentNode;
    var parentRects = parent.getBoundingClientRect();
    var offsetTop = e.clientY - parentRects.top;
    var height = parseInt(this.props.h, 10);
    this.setState({
      progress: offsetTop / height * 100
    });
  }
});

module.exports = VSlider2;



// WEBPACK FOOTER //
// ./src/views/Components/VSlider2.jsx